import { HttpResponse } from 'msw';

type LegacyBody = { command?: string };

export function handleVlanLegacy(
  body: LegacyBody,
): ReturnType<typeof HttpResponse.json> {
  const command = body.command ?? '';
  switch (command) {
    case 'get bonds':
      return HttpResponse.json(
        {
          Bond1: { lower_interfaces: ['P1', 'P2'] },
          Bond2: { lower_interfaces: ['P3'] },
        },
        { status: 200 },
      );
    case 'get bonds status':
      return HttpResponse.json(
        {
          Bond1: {
            status: 'up',
            lower_interfaces: {
              P1: { state: 'up' },
              P2: { state: 'up' },
            },
          },
          Bond2: {
            status: 'down',
            lower_interfaces: {
              P3: { state: 'down' },
            },
          },
        },
        { status: 200 },
      );
    case 'set bonds':
    case 'set global vlans':
    case 'set bridges':
    case 'update vlan port settings':
    case 'add vlan id':
    case 'remove vlan id':
      return HttpResponse.json({ ok: true }, { status: 200 });
    case 'get global vlans':
      return HttpResponse.json({ enabled: true }, { status: 200 });
    case 'get bridges':
      return HttpResponse.json(
        [
          {
            vlan_id: 0,
            ip: '192.168.1.10',
            sm: '255.255.255.0',
            gw: '192.168.1.1',
            forward: true,
            proxy_arp: false,
            dhcp_client: true,
            dhcp_provision: false,
            dhcp_filter: false,
          },
          {
            vlan_id: 10,
            ip: '10.0.10.1',
            sm: '255.255.255.0',
            gw: '',
            forward: false,
            proxy_arp: false,
            dhcp_client: false,
            dhcp_provision: false,
            dhcp_filter: false,
          },
        ],
        { status: 200 },
      );
    case 'get current bridge config':
      return HttpResponse.json(
        [
          {
            vlan_id: 0,
            ip: '192.168.1.10',
            sm: '255.255.255.0',
            gw: '192.168.1.1',
          },
          { vlan_id: 10, ip: '10.0.10.1', sm: '255.255.255.0', gw: '' },
        ],
        { status: 200 },
      );
    case 'vlan port settings':
      return HttpResponse.json(
        {
          P1: {
            default_vlan_id: 1,
            discard_tagged: false,
            discard_untagged: false,
            force_default_vlan_id: false,
          },
          P2: {
            default_vlan_id: 1,
            discard_tagged: false,
            discard_untagged: false,
            force_default_vlan_id: false,
          },
        },
        { status: 200 },
      );
    default:
      return HttpResponse.json(
        { error: 'not implemented', msg: `Mock missing for vlan:${command}` },
        { status: 400 },
      );
  }
}
